import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { Component } from 'react';
import { getVideoTextTrackId } from './text';
import { requestFullScreen } from './utils';
var getVolumeFromVideo = function getVolumeFromVideo(video) {
  var volume = video.volume;
  var isMuted = volume === 0;
  return {
    volume: volume,
    isMuted: isMuted
  };
};
var isSafari = typeof navigator !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
export var Video = /*#__PURE__*/function (_Component) {
  function Video() {
    var _this;
    _classCallCheck(this, Video);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Video, [].concat(args));
    _defineProperty(_this, "previousVolume", 1);
    _defineProperty(_this, "previousTime", -1);
    _defineProperty(_this, "videoRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "audioRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "hasCanPlayTriggered", false);
    _defineProperty(_this, "state", {
      isLoading: true,
      buffered: 0,
      currentTime: 0,
      volume: 1,
      status: 'paused',
      duration: 0,
      isMuted: false
    });
    _defineProperty(_this, "onLoadedData", function () {
      var defaultTime = _this.props.defaultTime;
      if (_this.currentElement) {
        _this.currentElement.currentTime = defaultTime;
      }
    });
    _defineProperty(_this, "onVolumeChange", function (event) {
      var video = event.target;
      var _getVolumeFromVideo = getVolumeFromVideo(video),
        volume = _getVolumeFromVideo.volume,
        isMuted = _getVolumeFromVideo.isMuted;
      _this.setState({
        volume: volume,
        isMuted: isMuted
      });
    });
    _defineProperty(_this, "onTimeUpdate", function (event) {
      var video = event.target;
      var onTimeChange = _this.props.onTimeChange;
      var duration = _this.state.duration;
      var flooredTime = Math.floor(video.currentTime);
      if (onTimeChange && flooredTime !== _this.previousTime) {
        onTimeChange(flooredTime, duration);
        _this.previousTime = flooredTime;
      }
      _this.setState({
        currentTime: video.currentTime
      });
      if (video.buffered.length) {
        var buffered = video.buffered.end(video.buffered.length - 1);
        _this.setState({
          buffered: buffered
        });
      }
    });
    _defineProperty(_this, "onCanPlay", function (event) {
      var onCanPlay = _this.props.onCanPlay;
      var video = event.target;
      var _getVolumeFromVideo2 = getVolumeFromVideo(video),
        volume = _getVolumeFromVideo2.volume,
        isMuted = _getVolumeFromVideo2.isMuted;
      _this.setState({
        volume: volume,
        isMuted: isMuted,
        isLoading: false,
        currentTime: video.currentTime,
        duration: video.duration
      });
      if (!_this.hasCanPlayTriggered) {
        // protect against browser firing this event multiple times
        _this.hasCanPlayTriggered = true;
        onCanPlay && onCanPlay(event);
      }
    });
    _defineProperty(_this, "onPlay", function () {
      _this.setState({
        status: 'playing'
      });
    });
    _defineProperty(_this, "onPause", function () {
      _this.setState({
        status: 'paused'
      });
    });
    _defineProperty(_this, "play", function () {
      _this.currentElement && _this.currentElement.play();
    });
    _defineProperty(_this, "pause", function () {
      _this.currentElement && _this.currentElement.pause();
    });
    _defineProperty(_this, "navigate", function (time) {
      _this.setState({
        currentTime: time
      });
      _this.currentElement && (_this.currentElement.currentTime = time);
    });
    _defineProperty(_this, "setVolume", function (volume) {
      _this.setState({
        volume: volume
      });
      _this.currentElement && (_this.currentElement.volume = volume);
    });
    _defineProperty(_this, "setPlaybackSpeed", function (playbackSpeed) {
      _this.currentElement && (_this.currentElement.playbackRate = playbackSpeed);
    });
    _defineProperty(_this, "requestFullscreen", function () {
      var sourceType = _this.props.sourceType;
      if (sourceType === 'video') {
        requestFullScreen(_this.currentElement);
      }
    });
    _defineProperty(_this, "mute", function () {
      var volume = _this.state.volume;
      _this.previousVolume = volume;
      _this.setVolume(0);
    });
    _defineProperty(_this, "unmute", function () {
      _this.setVolume(_this.previousVolume);
    });
    _defineProperty(_this, "toggleMute", function () {
      var volume = _this.videoState.volume;
      if (volume > 0) {
        _this.mute();
      } else {
        _this.unmute();
      }
    });
    _defineProperty(_this, "onDurationChange", function (event) {
      var video = event.target;
      _this.setState({
        duration: video.duration
      });
    });
    _defineProperty(_this, "onError", function (event) {
      var onError = _this.props.onError;
      var video = event.target;
      _this.setState({
        isLoading: false,
        status: 'errored',
        error: video.error
      });
      onError && onError(event);
    });
    _defineProperty(_this, "onWaiting", function () {
      _this.setState({
        isLoading: true
      });
    });
    _defineProperty(_this, "renderTracks", function (kind) {
      var _textTracks$kind;
      var textTracks = _this.props.textTracks;
      if (textTracks && Array.isArray((_textTracks$kind = textTracks[kind]) === null || _textTracks$kind === void 0 ? void 0 : _textTracks$kind.tracks)) {
        var _textTracks$kind2, _textTracks$kind3;
        var tracks = (_textTracks$kind2 = textTracks[kind]) === null || _textTracks$kind2 === void 0 ? void 0 : _textTracks$kind2.tracks;
        var selectedIndex = (_textTracks$kind3 = textTracks[kind]) === null || _textTracks$kind3 === void 0 ? void 0 : _textTracks$kind3.selectedTrackIndex;
        return /*#__PURE__*/React.createElement(React.Fragment, null, tracks === null || tracks === void 0 ? void 0 : tracks.map(function (_ref, index) {
          var src = _ref.src,
            lang = _ref.lang,
            label = _ref.label;
          return /*#__PURE__*/React.createElement("track", {
            key: index,
            id: getVideoTextTrackId(kind, lang),
            kind: kind,
            src: src,
            srcLang: lang,
            label: label,
            default: index === selectedIndex
          });
        }));
      }
      return null;
    });
    return _this;
  }
  _inherits(Video, _Component);
  return _createClass(Video, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var src = this.props.src;
      var _this$state = this.state,
        currentTime = _this$state.currentTime,
        status = _this$state.status;
      var hasSrcChanged = prevProps.src !== src;
      if (hasSrcChanged) {
        this.hasCanPlayTriggered = false;
        // TODO: add test to cover this case
        if (status === 'playing') {
          this.play();
        }
        this.navigate(currentTime);
      }
    }
  }, {
    key: "videoState",
    get: function get() {
      var _this2 = this;
      var _this$state2 = this.state,
        currentTime = _this$state2.currentTime,
        volume = _this$state2.volume,
        status = _this$state2.status,
        duration = _this$state2.duration,
        buffered = _this$state2.buffered,
        isMuted = _this$state2.isMuted,
        isLoading = _this$state2.isLoading,
        error = _this$state2.error;
      return {
        currentTime: currentTime,
        currentActiveCues: function currentActiveCues(kind, lang) {
          var _this2$videoRef$curre;
          return (_this2$videoRef$curre = _this2.videoRef.current) === null || _this2$videoRef$curre === void 0 || (_this2$videoRef$curre = _this2$videoRef$curre.textTracks.getTrackById(getVideoTextTrackId(kind, lang))) === null || _this2$videoRef$curre === void 0 ? void 0 : _this2$videoRef$curre.activeCues;
        },
        volume: volume,
        status: status,
        duration: duration,
        buffered: buffered,
        isMuted: isMuted,
        isLoading: isLoading,
        error: error
      };
    }
  }, {
    key: "currentElement",
    get: function get() {
      var sourceType = this.props.sourceType;
      if (sourceType === 'video' && this.videoRef.current) {
        return this.videoRef.current;
      } else if (sourceType === 'audio' && this.audioRef.current) {
        return this.audioRef.current;
      } else {
        return undefined;
      }
    }
  }, {
    key: "actions",
    get: function get() {
      var play = this.play,
        pause = this.pause,
        navigate = this.navigate,
        setVolume = this.setVolume,
        setPlaybackSpeed = this.setPlaybackSpeed,
        requestFullscreen = this.requestFullscreen,
        mute = this.mute,
        unmute = this.unmute,
        toggleMute = this.toggleMute;
      return {
        play: play,
        pause: pause,
        navigate: navigate,
        setVolume: setVolume,
        setPlaybackSpeed: setPlaybackSpeed,
        requestFullscreen: requestFullscreen,
        mute: mute,
        unmute: unmute,
        toggleMute: toggleMute
      };
    }
  }, {
    key: "render",
    value: function render() {
      var videoState = this.videoState,
        actions = this.actions;
      var _this$props = this.props,
        sourceType = _this$props.sourceType,
        poster = _this$props.poster,
        src = _this$props.src,
        children = _this$props.children,
        autoPlay = _this$props.autoPlay,
        controls = _this$props.controls,
        preload = _this$props.preload,
        crossOrigin = _this$props.crossOrigin;
      var props = {
        src: src,
        preload: preload,
        controls: controls,
        autoPlay: autoPlay,
        onLoadedData: this.onLoadedData,
        onPlay: this.onPlay,
        onPause: this.onPause,
        onVolumeChange: this.onVolumeChange,
        onTimeUpdate: this.onTimeUpdate,
        onCanPlay: this.onCanPlay,
        onDurationChange: this.onDurationChange,
        onError: this.onError,
        onWaiting: this.onWaiting,
        crossOrigin: crossOrigin
      };
      if (sourceType === 'video') {
        return children(
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/media-has-caption
        React.createElement("video", _extends({
          ref: this.videoRef,
          poster: poster
        }, props), this.renderTracks('subtitles'), this.renderTracks('captions'), this.renderTracks('descriptions'), this.renderTracks('chapters'), this.renderTracks('metadata')), videoState, actions, this.videoRef);
      } else {
        // eslint-disable-next-line jsx-a11y/media-has-caption
        return children( /*#__PURE__*/React.createElement("audio", _extends({
          ref: this.audioRef
        }, props)), videoState, actions, this.audioRef);
      }
    }
  }]);
}(Component);
_defineProperty(Video, "defaultProps", {
  defaultTime: 0,
  sourceType: 'video',
  autoPlay: false,
  controls: false,
  preload: isSafari ? 'auto' : 'metadata'
});